// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button, Badge } from '@/components/ui/core';
import { PasswordInput } from '@/components/ui/inputs';
import { IconLock, IconArrowLeft, IconShieldCheck, IconSparkles, IconCheck, IconX } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function ResetModern() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Reset password:', password);
  };

  const requirements = [
    { label: 'At least 8 characters', met: password.length >= 8 },
    { label: 'Contains uppercase letter', met: /[A-Z]/.test(password) },
    { label: 'Contains lowercase letter', met: /[a-z]/.test(password) },
    { label: 'Contains a number', met: /[0-9]/.test(password) },
    { label: 'Contains special character', met: /[!@#$%^&*(),.?":{}|<>]/.test(password) },
  ];

  const allRequirementsMet = requirements.every((r) => r.met);
  const passwordsMatch = password === confirmPassword;
  const canSubmit = allRequirementsMet && passwordsMatch && confirmPassword.length > 0;

  return (
    <AuthLayoutWrapper variant="modern">
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/reset-password"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <Stack align="center" gap="xs">
          <Badge
            leftSection={<IconSparkles size={12} />}
            variant="gradient"
            gradient={{ from: 'green', to: 'teal' }}
            size="lg"
          >
            Secure Reset
          </Badge>
          <Title order={2} ta="center" mt="sm">Create new password</Title>
          <Text c="dimmed" size="sm" ta="center" maw={300}>
            Choose a strong password that you haven't used before.
          </Text>
        </Stack>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <PasswordInput
              label="New password"
              placeholder="Create a strong password"
              leftSection={<IconLock size={16} />}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              size="md"
              radius="md"
            />

            {/* Requirements checklist */}
            {password && (
              <Stack gap={6}>
                {requirements.map((req) => (
                  <Group key={req.label} gap="xs">
                    {req.met ? (
                      <IconCheck size={14} color="var(--mantine-color-green-6)" />
                    ) : (
                      <IconX size={14} color="var(--mantine-color-gray-5)" />
                    )}
                    <Text size="xs" c={req.met ? 'green' : 'dimmed'}>
                      {req.label}
                    </Text>
                  </Group>
                ))}
              </Stack>
            )}

            <PasswordInput
              label="Confirm password"
              placeholder="Confirm your password"
              leftSection={<IconLock size={16} />}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              size="md"
              radius="md"
              error={confirmPassword && !passwordsMatch ? "Passwords don't match" : undefined}
            />

            <Button
              type="submit"
              fullWidth
              size="md"
              radius="md"
              variant="gradient"
              gradient={{ from: 'green', to: 'teal' }}
              disabled={!canSubmit}
              leftSection={<IconShieldCheck size={18} />}
            >
              Update password
            </Button>
          </Stack>
        </form>

        {/* Back to Login */}
        <Center>
          <Button
            component={Link}
            to="/app/demo/auth-pages/login/modern"
            variant="subtle"
            leftSection={<IconArrowLeft size={14} />}
          >
            Back to login
          </Button>
        </Center>
      </Stack>
    </AuthLayoutWrapper>
  );
}
